import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import styles from '../form.module.scss';

class FloorFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    var { minFloors, maxFloors, tabIndex } = this.props;

    return (
      <Row>
        <Col xs={6}>
          <InputGroup>
            <InputGroupAddon
              tag="label"
              htmlFor="minFloors"
              addonType="prepend"
              className={styles.inlineInputGroupAddon}
            >
              <FontAwesome name="home" className={BS.inputGroupText} />
            </InputGroupAddon>
            <Input
              {...minFloors.input}
              placeholder="No Min"
              tabIndex={tabIndex}
              onChange={e => {
                const val = e.target.value;
                minFloors.input.onChange(val !== '' ? parseInt(val, 0) : val);
              }}
            />
          </InputGroup>
        </Col>
        <Col xs={6}>
          <InputGroup>
            <InputGroupAddon
              tag="label"
              htmlFor="maxFloors"
              addonType="prepend"
              className={styles.inlineInputGroupAddon}
            >
              <FontAwesome name="home" className={BS.inputGroupText} />
            </InputGroupAddon>
            <Input
              {...maxFloors.input}
              placeholder="No Max"
              tabIndex={tabIndex ? tabIndex + 1 : tabIndex}
              onChange={e => {
                const val = e.target.value;
                maxFloors.input.onChange(val !== '' ? parseInt(val, 0) : val);
              }}
            />
          </InputGroup>
        </Col>
      </Row>
    );
  }
}

export default FloorFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/floor-filter.js